import {
  ConfigurationPanel,
  ConfigurationPanelHeader,
  ConfigurationPanelBody,
  ConfigurationPanelFooter,
} from "../../../Components/ConfigurationPanel";
import { Button } from "V2.0/common/button";
import DefaultEndForm from "./DefaultEndForm";
import useDefaultEndForm from "./useDefaultEndForm";

export default DefaultEnd;

function DefaultEnd(props) {
  const { node, closePanel, onSave, validationErrors } = props;

  const { formState, errors, updateFormState, validate } = useDefaultEndForm(
    node.data,
    validationErrors,
  );

  const handleSave = () => {
    if (!validate()) {
      return;
    }

    onSave(node.id, {
      ...node.data,
      ...formState,
    });

    closePanel();
  };

  return (
    <ConfigurationPanel>
      <ConfigurationPanelHeader>
        <p>Configure End Node</p>
      </ConfigurationPanelHeader>
      <ConfigurationPanelBody>
        <DefaultEndForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </ConfigurationPanelBody>
      <ConfigurationPanelFooter>
        <div className="flex justify-end items-center gap-x-2">
          <Button
            outline
            onClick={closePanel}
          >
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </div>
      </ConfigurationPanelFooter>
    </ConfigurationPanel>
  );
}
